import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { GovernmentIdState, governmentIdFeatureKey } from '../reducers/government-id.reducer';
import * as govIdState from '../reducers/government-id.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, GovernmentIdState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee govId SUB STATE
export const getGovIdState = createSelector(getMainEmployeeState, state => state[governmentIdFeatureKey]);
//#endregion

//#region Employee govId SUB STATE
export const getGovIdRequest = createSelector(getGovIdState, govIdState.getgovIdRequest);
export const getGovIdResponse = createSelector(getGovIdState, govIdState.getgovIdResponse);
export const getGovIdFailure = createSelector(getGovIdState, govIdState.getgovIdFailure);
//#endregion
